module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-kingmaker.223852bf.png";